<script setup lang="ts">
interface IProps {
    error: string;
    researchTitle?: string;
    wrapperId: string;
}
const {
    wrapperId,
    error,
    researchTitle = 'جستجوی مجدد',
} = defineProps<IProps>();
const emit = defineEmits<{
    research: [];
}>();
</script>

<template>
    <div :id="wrapperId" class="inner">
        <img
            src="~/assets/files/errors/connectionLost.svg"
            alt="reserve error"
        />
        <p>{{ error }}</p>
        <mr-button @click="emit('research')">
            {{ researchTitle }}
        </mr-button>
    </div>
</template>

<style scoped lang="scss">
.inner {
    background-color: white;
    @include shadow();
    border-radius: 10px;
    padding: 30px 10px 100px;
    margin-top: 5px;
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    p {
        margin: 0 0 32px;
        font-size: 14px;
        white-space: pre-wrap;
        text-align: center;
    }
    img {
        @include mobile-only {
            max-width: 100%;
        }
    }
    :deep(button) {
        width: 296px;
    }
}
</style>
